import {
  HttpContextToken,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { of, tap } from 'rxjs';
import { ApiCacheService } from './api-cache.service';

export const SKIP_API_CACHE = new HttpContextToken<boolean>(() => false);

export const cacheHttpInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET' || req.context.get(SKIP_API_CACHE)) {
    return next(req);
  }

  const cacheService = inject(ApiCacheService);
  const cacheKey = req.urlWithParams;
  const cachedResponse = cacheService.get(cacheKey);

  if (cachedResponse !== null) {
    return of(
      new HttpResponse({
        body: cachedResponse,
        status: 200,
        statusText: 'OK',
        url: req.urlWithParams,
      })
    );
  }

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && event.ok) {
        cacheService.set(cacheKey, event.body, 5 * 60 * 1000);
      }
    })
  );
};
